import { Separator } from '@/components/ui/separator';
import { Github, Linkedin, Twitter } from 'lucide-react';

const footerLinks = {
  Services: [
    { label: 'Acodia Learn', href: '/learn' },
    { label: 'Acodia Launch', href: '/launch' },
    { label: 'Acodia Defend', href: '/defend' },
    { label: 'Acodia Reach', href: '/reach' },
  ],
  Company: [
    { label: 'About Acodia', href: '/#why' },
    { label: 'Blog', href: '/blog' },
    { label: 'FAQ', href: '/#faq' },
    { label: 'Contact', href: '/#contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Cookie Policy', href: '/cookies' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'GDPR Statement', href: '/gdpr' },
  ],
};

const socials = [
  { icon: Linkedin, href: 'https://www.linkedin.com/company/acodia', label: 'LinkedIn' },
  { icon: Twitter,  href: 'https://twitter.com/acodia',             label: 'Twitter' },
  { icon: Github,   href: 'https://github.com/Dev-Acodia',          label: 'GitHub' },
];

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="pt-14 pb-8 border-t"
      style={{ background: 'var(--l1)', borderColor: 'var(--b1)' }}
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mb-12">
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <h4 className="font-display text-sm font-bold mb-4" style={{ color: 'var(--white)' }}>{section}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                      className="font-body text-sm transition-colors duration-200"
                      style={{ color: 'var(--ts)' }}
                      onMouseEnter={(e) => e.currentTarget.style.color = 'var(--white)'}
                      onMouseLeave={(e) => e.currentTarget.style.color = 'var(--ts)'}
                      onClick={
                        link.href === '/#why'
                          ? (e) => {
                              e.preventDefault();
                              if (window.location.pathname === '/') {
                                document.getElementById('why')?.scrollIntoView({ behavior: 'smooth' });
                              } else {
                                window.location.href = '/#why';
                              }
                            }
                          : undefined
                      }
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <Separator className="mb-8" style={{ background: 'var(--b1)' }} />

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a href="/" aria-label="Acodia — Home" className="flex items-center">
              <img
                src="/images/logo/logo-footer-36.png"
                alt="Acodia"
                style={{ height: 28, width: 'auto', display: 'block' }}
              />
            </a>
            <span className="font-body text-xs" style={{ color: 'var(--te)' }}>
              © {new Date().getFullYear()} Acodia Ltd. All rights reserved.
            </span>
          </div>

          {/* Socials */}
          <div data-testid="footer-social-links" className="flex items-center gap-3">
            {socials.map((s) => {
              const Icon = s.icon;
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={s.label}
                  className="p-2 rounded-md transition-all duration-200"
                  style={{ color: 'var(--ts)' }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = 'var(--white)';
                    e.currentTarget.style.background = 'rgba(139,92,246,0.08)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = 'var(--ts)';
                    e.currentTarget.style.background = 'transparent';
                  }}
                >
                  <Icon size={16} />
                </a>
              );
            })}
          </div>
        </div>

        {/* Legal Microcopy */}
        <div className="mt-6 text-center sm:text-left">
          <p className="font-body text-xs mb-1.5" style={{ color: 'var(--te)' }}>
            Phone:{' '}
            <a href="tel:+443301221202" style={{ color: 'var(--te)' }} className="hover:underline">
              0330 122 1202
            </a>
          </p>
          <p className="font-body text-xs" style={{ color: 'var(--te)' }}>
            Acodia Ltd. Registered in England and Wales, Companies House No. 15412512.
            Registered office: 20 Wenlock Road, London, N1 7GU, United Kingdom. ICO Registration Number: ZB786356.
          </p>
        </div>
      </div>
    </footer>
  );
};
